import { Typography } from '@mui/material';
import cn from 'classnames';
import React, { FC } from 'react';

import Google_Pay_svg from '../../../../assets/images/basket/Google_Pay.svg';
import MasterCard_svg from '../../../../assets/images/basket/MasterCard.svg';
import Mir_svg from '../../../../assets/images/basket/Mir.svg';
import Visa_svg from '../../../../assets/images/basket/Visa.svg';
import { useBasket } from '../../../../hooks/useBasket';
import { useUser } from '../../../../hooks/useUser';

import ControlFields from './ControlFields';
import styles from './PaymentMethod.module.sass';

const PaymentMethod: FC = () => {
  const { checkout } = useBasket();
  const { loggedIn } = useUser();
  return (
    <div
      className={cn(styles.block, {
        [styles.active]: !checkout.is_physical_person,
        [styles.login]: !loggedIn,
        [styles.radio_active]:
          checkout.receiving_method === 'delivery' &&
          checkout.is_physical_person,
      })}
    >
      <div className={cn(styles.wrapper)}>
        <Typography variant="h5" fontWeight={700}>
          Способ оплаты
        </Typography>
        <div className={cn(styles.iconsWrapper)}>
          <ControlFields />
          <div className={styles.icons}>
            <img src={Visa_svg} alt="Visa" />
            <img src={MasterCard_svg} alt="MasterCard" />
            <img src={Mir_svg} alt="Mir" />
            <img src={Google_Pay_svg} alt="Google_Pay" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
